'use client';
interface OptimaLogoProps {
  width?: number;
  height?: number;
  className?: string;
  isSquare?: boolean;
}

export const OptimaLogo = ({ width, height, className, isSquare = false }: OptimaLogoProps) => {
  return (
    <>
      {isSquare ? (
        <svg
          viewBox='0 0 300 300'
          xmlns='http://www.w3.org/2000/svg'
          width={width || 47}
          height={height || 47}
          className={className}
        >
          <path
            d='m282.61 17.39c-10.68-10.74-25.46-17.39-41.8-17.39h-72.39c-1.58 0-3.13.11-4.68.24h-104.78c-32.56 0-58.96 26.39-58.96 58.96v72.39c0 32.56 26.4 58.96 58.96 58.96h30.88l63.26-63.26h-31.56c-8.42 0-15.25-6.83-15.25-15.25s6.83-15.25 15.25-15.25h68.25c8.42 0 15.25 6.83 15.25 15.25v65.24c0 8.42-6.83 15.25-15.25 15.25s-15.25-6.83-15.25-15.25v-28.29l-65.08 65.08v26.96c0 32.56 26.4 58.96 58.96 58.96h72.39c32.56 0 58.96-26.4 58.96-58.96v-104.77c.12-1.55.24-3.1.24-4.68v-72.38c0-16.34-6.65-31.12-17.39-41.8z'
            fill='#0075b4'
          />
        </svg>
      ) : (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 600 401.42'
          width={width || 256}
          height={height || 167}
          className={className}
          aria-description='Optima logo'
        >
          <g>
            <path
              className='stroke-none light:fill-[#323232] dark:fill-white'
              d='M92.9,355.24c0,25.03-18.34,46.18-46.45,46.18S0,380.27,0,355.24s18.34-46.18,46.45-46.18,46.45,21.02,46.45,46.18ZM72.15,355.24c0-14.99-10.71-27.58-25.7-27.58s-25.7,12.58-25.7,27.58,10.71,27.58,25.7,27.58,25.7-12.72,25.7-27.58Z'
            />
            <path
              className='stroke-none light:fill-[#323232] dark:fill-white'
              d='M166.26,367.02h-24.23v32.66h-20.88v-88.88h45.11c21.55,0,31.46,12.98,31.46,27.98s-9.91,28.25-31.46,28.25ZM164.66,329.4h-22.62v19.14h22.62c7.9,0,12.18-4.42,12.18-9.77s-4.28-9.37-12.18-9.37Z'
            />
            <path
              className='stroke-none light:fill-[#323232] dark:fill-white'
              d='M295.18,310.8v18.61h-27.71v70.28h-20.88v-70.28h-27.98v-18.61h76.57Z'
            />
            <path
              className='stroke-none light:fill-[#323232] dark:fill-white'
              d='M342.04,399.68h-20.88v-88.88h20.88v88.88Z'
            />
            <path
              className='stroke-none light:fill-[#323232] dark:fill-white'
              d='M427.71,376.92l29.99-66.13h22.76v88.88h-20.88v-47.66l-21.55,47.66h-21.42l-21.02-47.66v47.66h-20.88v-88.88h23.56l29.45,66.13Z'
            />
            <path
              className='stroke-none light:fill-[#323232] dark:fill-white'
              d='M569.48,380.67h-36.41l-8.43,19.01h-21.15l38.55-88.88h19.41l38.55,88.88h-22.09l-8.43-19.01ZM541.37,362.06h19.81l-9.77-22.49-10.04,22.49Z'
            />
          </g>
          <path
            className='fill-[#0075b4] stroke-none'
            d='M397.15,13.08c-8.03-8.08-19.15-13.08-31.45-13.08h-54.46c-1.19,0-2.35.09-3.52.18h-78.82c-24.5,0-44.35,19.86-44.35,44.35v54.46c0,24.5,19.86,44.35,44.35,44.35h23.23l47.58-47.58h-23.74c-6.34,0-11.47-5.14-11.47-11.47s5.14-11.47,11.47-11.47h51.34c6.34,0,11.47,5.14,11.47,11.47v49.08c0,6.34-5.14,11.47-11.47,11.47s-11.47-5.14-11.47-11.47v-21.28l-48.96,48.96v20.28c0,24.5,19.86,44.35,44.35,44.35h54.46c24.5,0,44.35-19.86,44.35-44.35v-78.82c.09-1.16.18-2.33.18-3.52v-54.46c0-12.29-5.01-23.41-13.08-31.45Z'
          />
        </svg>
      )}
    </>
  );
};
